<!-- <mat-toolbar color="primary">
    <button [fxShow.lt-md]="true" [fxShow]="false"  mat-icon-button (click)="openSidenav()">
        <mat-icon>menu</mat-icon>
    </button>
    <span>Award/Decline Requests</span>
</mat-toolbar> -->
<div class="content" fxLayout="column" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="16px" [@routeAnimation]="true">
    <mat-tab-group #tabGroup mat-stretch-tabs>

        <mat-tab [disabled]="!hasRole('ADMIN|FOUNDATIONAPPROVER|CITAPPROVER')" label="LG&E-KU Community Grants">
            <mat-card *ngIf="tabGroup.selectedIndex===0">
                <mat-tab-group #tabGroupCG>

                    <mat-tab label="Submitted Request(s)">
                        <form-status-table-component *ngIf="tabGroupCG.selectedIndex ===0" [formType]="'CG'" [data]='formCGOpenRequests' [displayedColumns]='columnsCGPPOpenRequests'>
                        </form-status-table-component>
                    </mat-tab>

                    <mat-tab label="Compose Notification Email(s)">
                        <form-status-table-component *ngIf="tabGroupCG.selectedIndex ===1" [tableType]="'Email'" [formType]="'CG'" [data]='formCGClosedRequests' [displayedColumns]='columnsCGPPClosedRequests'>
                        </form-status-table-component>
                    </mat-tab>

                </mat-tab-group>
            </mat-card>
        </mat-tab>

        <mat-tab [disabled]="!hasRole('ADMIN|PFTPAPPROVER')" label="Plant for the Planet">
            <mat-card *ngIf="tabGroup.selectedIndex===1 ">
                <mat-tab-group #tabGroupPP>

                    <mat-tab label="Submitted Request(s)">
                        <form-status-table-component *ngIf="tabGroupPP.selectedIndex ===0" [data]='formPPOpenRequests' [formType]="'PP'" [displayedColumns]='columnsCGPPOpenRequests'>
                        </form-status-table-component>
                    </mat-tab>

                    <mat-tab label="Compose Notification Email(s)">
                        <form-status-table-component *ngIf="tabGroupPP.selectedIndex ===1" [tableType]="'Email'" [formType]="'PP'" [data]='formPPClosedRequests' [displayedColumns]='columnsCGPPClosedRequests'>
                        </form-status-table-component>
                    </mat-tab>

                </mat-tab-group>
            </mat-card>
        </mat-tab>

        <mat-tab [disabled]="!hasRole('ADMIN|FOUNDATIONAPPROVER|CITAPPROVER')" label="Event Sponsorship">
            <mat-card *ngIf="tabGroup.selectedIndex===2">
                <mat-tab-group #tabGroupES>

                    <mat-tab label="Submitted Request(s)">
                        <form-status-table-component *ngIf="tabGroupES.selectedIndex ===0" [formType]="'ES'" [data]='formESOpenRequests' [displayedColumns]='columnsESOpenRequests'>
                        </form-status-table-component>
                    </mat-tab>

                    <mat-tab label="Compose Notification Email(s)">
                        <form-status-table-component *ngIf="tabGroupES.selectedIndex ===1" [tableType]="'Email'" [formType]="'ES'" [data]='formESClosedRequests' [displayedColumns]='columnsESClosedRequests'>
                        </form-status-table-component>
                    </mat-tab>

                </mat-tab-group>
            </mat-card>
        </mat-tab>

    </mat-tab-group>
</div>




<!-- <mat-tab [disabled]="!hasRole('ADMIN|CITAPPROVER')" label="Community Investment Funding ">
    <mat-card *ngIf="tabGroup.selectedIndex===2 ">
        <mat-tab-group #tabGroupCI>
            <mat-tab label="Submitted Request(s)">
                <form-status-table-component *ngIf="tabGroupCI.selectedIndex ===0" [formType]="CI"
                    [data]='formCIOpenRequests' [displayedColumns]='columnsOpenRequests'>
                </form-status-table-component>
            </mat-tab>
            <mat-tab label="Compose Notification Email(s)">
                <form-status-table-component *ngIf="tabGroupCI.selectedIndex ===1" [tableType]="'Email'" [formType]="CI"
                    [data]='formCIClosedRequests' [displayedColumns]='columnsClosedRequests'>
                </form-status-table-component>
            </mat-tab>
        </mat-tab-group>
    </mat-card>
</mat-tab>



<mat-tab [disabled]="!hasRole('ADMIN|FOUNDATIONAPPROVER')" label="LG&E-KU Foundation ">
    <mat-card *ngIf="tabGroup.selectedIndex===1">
        <mat-tab-group #tabGroupFO>
            <mat-tab label="Submitted Request(s)">
                <form-status-table-component *ngIf="tabGroupFO.selectedIndex ===0" [formType]="FO"
                    [data]='formFOOpenRequests' [displayedColumns]='columnsOpenRequests'>
                </form-status-table-component>
            </mat-tab>
            <mat-tab label="Compose Notification Email(s)">
                <form-status-table-component *ngIf="tabGroupFO.selectedIndex ===1" [tableType]="'Email'" [formType]="FO"
                    [data]='formFOClosedRequests' [displayedColumns]='columnsClosedRequests'>
                </form-status-table-component>
            </mat-tab>
        </mat-tab-group>
    </mat-card>
</mat-tab> -->